import { render, staticRenderFns } from "./society.vue?vue&type=template&id=2f821c22&scoped=true&"
import script from "./society.vue?vue&type=script&lang=js&"
export * from "./society.vue?vue&type=script&lang=js&"
import style0 from "./society.vue?vue&type=style&index=0&id=2f821c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f821c22",
  null
  
)

export default component.exports